export const LogoChip = ({ small }) => (
  <img
    src="/pamak-logo.png"
    alt="PaMak"
    className={`logo-img ${small ? "logo-img-sm" : ""}`}
    draggable={false}
  />
);

export default LogoChip;
